import MinutesToText from '@/components/ezuro/common/MinutesToText.vue'
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default {
  name: 'ShiftPatternEdit',
  components: {
    MinutesToText
  },
  data () {
    return {
      editEl: {
        type: 'work',
        length: 420
      },
      key: null
    }
  },
  validations: {
    editEl: {
      type: { required },
      length: { required }
    }
  },
  computed: {
    typeOptions () {
      const types = [
        { value: 'work', text: this.$t('shift.is_working') },
        { value: 'rest', text: this.$t('shift.not_working') }
      ];
      return types;
    }
  },
  methods: {
    show (key, data) {
      this.v$.$reset();
      this.editEl = this.BasicHelper.cloneObject(data);
      this.key = key;
      this.$refs['modal-window'].show();
    },
    close () {
      this.$refs['modal-window'].hide();
    },
    save () {
      this.v$.$touch();
      if (!this.v$.$invalid) {
        this.$emit('updatePattern', { key: this.key, data: this.editEl });
        this.close();
      }
    },
    remove () {
      this.$emit('removeByKey', this.key);
      this.close();
    }
  },
  setup () {
    return { v$: useVuelidate() }
  }
}
